if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
      this.activateAliButton = false;
      this.activateJDButton = false;
      this.currentVariantId = null;

      // Listen for variant changes
      this.form.addEventListener('change', this.onVariantChange.bind(this));
      
      // Set initial variant
      this.updateCurrentVariant();

      if(sessionStorage.getItem('userGeoCode')) {
        this.alify();
        this.jdify();
      }
      else {
        document.addEventListener('geoCodeDefined', () => this.alify());
        document.addEventListener('geoCodeDefined', () => this.jdify());
      }
    }

    // 🆕 NEW: Handle variant changes
    onVariantChange() {

      console.log('Variant changed:', this.currentVariantId);

      this.updateCurrentVariant();
      // Re-check button states when variant changes
      if(sessionStorage.getItem('userGeoCode')) {
        this.alify();
        this.jdify();
      }
    }

    // 🆕 NEW: Update current variant ID
    updateCurrentVariant() {
      const variantInput = this.form.querySelector('[name="id"]');
      if (variantInput && variantInput.value) {
        this.currentVariantId = variantInput.value;
      } else {
        // Fallback to first variant if no selection
        const firstVariantId = Object.keys(Shopify.alify?.variants || {})[0];
        this.currentVariantId = firstVariantId;
      }
    }

    // 🆕 NEW: Get current variant data
    getCurrentVariantData(shopifyObject) {
      if (!shopifyObject?.variants || !this.currentVariantId) return null;
      return shopifyObject.variants[this.currentVariantId];
    }

    alify() {
      const geoCode = sessionStorage.getItem('userGeoCode');
      this.activateAliButton = Shopify.alify?.regions?.includes(geoCode) && Shopify.alify;
      
      if(this.activateAliButton) {
        const currentVariant = this.getCurrentVariantData(Shopify.alify);
        const hasVariantLink = currentVariant && currentVariant.link;
        
        // Only show Ali button if current variant has a link or there's a main link
        if (hasVariantLink || Shopify.alify.link_main) {
          this.submitButton.innerHTML = `
            <span>${Shopify.alify.text}</span>
          `;
          if(this.submitButton.classList.contains('quick-add__submit')) {
            this.submitButton.style.display = 'none';
          }
        } else {
          this.activateAliButton = false;
        }
      }
    }

    jdify() {
      const geoCode = sessionStorage.getItem('userGeoCode');
      this.activateJDButton = Shopify.jdify?.regions?.includes(geoCode) && Shopify.jdify;
      
      if(this.activateJDButton) {
        const currentVariant = this.getCurrentVariantData(Shopify.jdify);
        const hasVariantLink = currentVariant && currentVariant.link;
        
        // Only show JD button if current variant has a link or there's a main link
        if (hasVariantLink || Shopify.jdify.link_main) {
          this.submitButton.innerHTML = `
            <span>${Shopify.jdify.text}</span>
          `;
          if(this.submitButton.classList.contains('quick-add__submit')) {
            this.submitButton.style.display = 'none';
          }
        } else {
          this.activateJDButton = false;
        }
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if(this.activateAliButton) {
        const currentVariant = this.getCurrentVariantData(Shopify.alify);
        const link = (currentVariant && currentVariant.link) || Shopify.alify.link_main;
        if (link) {
          window.open(link, '_blank');
          return;
        }
      }

      if(this.activateJDButton) {
        const currentVariant = this.getCurrentVariantData(Shopify.jdify);
        const link = (currentVariant && currentVariant.link) || Shopify.jdify.link_main;
        if (link) {
          window.open(link, '_blank');
          return;
        }
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      formData.append('attributes[is_human]', 'true');
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (window.location.pathname.includes('/cart')) {
            window.location.reload();
            return;
          }
          
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    } 
  });

  // 🆕 Listen for async loaded product cards and force upgrade custom elements
  document.addEventListener('recommendations:loaded', () => {
    console.log('Recommendations loaded - upgrading new product forms');
    
    // Find all product-form elements that haven't been upgraded yet
    const productForms = document.querySelectorAll('product-form:not(:defined)');
    
    // Force the custom element to upgrade
    productForms.forEach(form => {
      // CustomElements.upgrade() will trigger the constructor
      customElements.upgrade(form);
    });

  });
}